<template>
  <el-dialog
      :visible.sync="visible"
      title="发票详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"

    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="4">
          <MLabel label="发票号" :value="dataForm.code" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="开票时间" :value="dataForm.operateDate" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="卖方名称" :value="dataForm.sellerName" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="制单人" :value="dataForm.creatorName" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="制单时间" :value="dataForm.createDate" size="normal"></MLabel>
        </el-col>

      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;" v-if="dataForm.remark">
        <el-col :span="24">
          <MLabel label="备注" :value="dataForm.remark" size="normal"></MLabel>
        </el-col>
      </el-row>
      <SweetTable ref="table" v-if="id" url="/erp/receipt/detail/page" :is-page="false" :height="300"
                  :query-form="{pid:id,page:1,limit:10000}"
                  :before-table-binding="beforeTableBinding"
                  :summaries-column="['totalAmount','count']" api-version="v2">
        <el-table-column prop="orderCode" label="订单编号" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="product.code" label="品番号" min-width="90" align="center" header-align="center"
                         v-if="productType==='产品'"></el-table-column>
        <el-table-column prop="product.skuCode" label="SKU" min-width="90" align="center" header-align="center"
                         v-if="productType==='产品'"></el-table-column>
        <el-table-column prop="product.name" label="品名" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.color" label="颜色" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.size" label="规格" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.attr1" label="幅宽" min-width="90" v-if="productType==='原料'" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.attr2" label="克重" min-width="90" v-if="productType==='原料'" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.nameZh" label="中文品名" min-width="120" align="center" header-align="center"
                         v-if="productType==='产品'"></el-table-column>
        <el-table-column prop="price" width="120" label="单价" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="count" label="数量" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="totalAmount" width="120" label="金额" align="center" header-align="center">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BigNumber from 'bignumber.js'
import MLabel from '@/components/MLabel/index.vue'

export default {
  name: 'PayDetailDialog',
  components: { MLabel },
  data () {
    return {
      dataForm: {},
      visible: false,
      id: '',
      productType: ''
    }
  },
  methods: {
    init (id) {
      this.id = id
      this.getInfo()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    getInfo () {
      if (!this.id) {
        return
      }
      this.$api2.get(`/erp/receipt/${this.id}`).then(res => {
        this.dataForm = {
          ...res
        }
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        if (!this.productType) {
          this.productType = row.product.type
        }
        row.totalAmount = new BigNumber(row.count).multipliedBy(row.price).toFixed(3)
      })
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
